import { useTranslation } from 'react-i18next';
import { AlertTriangle, RotateCw } from 'lucide-react';

/**
 * Shared list/query error state (NUMBER_ONE_PLAN W2.4 / A7). List pages had
 * loading + empty states but no error state, so a failed fetch fell through
 * to "empty" — telling the user they have no data when in fact the request
 * died. This surfaces the failure honestly and offers a retry.
 */
export function ErrorState({
  onRetry,
  title,
  message,
  compact,
}: {
  onRetry?: () => void;
  title?: string;
  message?: string;
  compact?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div
      role="alert"
      className={
        'rounded-2xl border border-rose-200 bg-rose-50/60 text-center ' +
        (compact ? 'px-4 py-6' : 'px-6 py-10')
      }
    >
      <AlertTriangle className="mx-auto h-6 w-6 text-rose-500" />
      <p className="mt-3 text-sm font-semibold text-rose-900">{title ?? t('common.error_title')}</p>
      <p className="mt-1 text-sm text-rose-700">{message ?? t('common.error_body')}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-4 inline-flex items-center gap-1.5 rounded-md border border-rose-300 bg-white px-3.5 py-1.5 text-sm font-semibold text-rose-800 hover:bg-rose-100"
        >
          <RotateCw className="h-3.5 w-3.5" />
          {t('common.retry')}
        </button>
      )}
    </div>
  );
}
